"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      padding: "".concat(spacing(2), " 0")
    },
    sideBar: {
      minWidth: 215
    },
    content: {
      width: 'calc(100% - 215px)',
      padding: spacing(2)
    }
  };
});

var SettingsLayout = function SettingsLayout(_ref2) {
  var children = _ref2.children,
      sidebar = _ref2.sidebar;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    className: classes.root,
    wrap: "nowrap",
    "data-testid": "SettingsLayout"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: classes.sideBar
  }, sidebar), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    className: classes.content
  }, children));
};

SettingsLayout.propTypes = {
  children: _propTypes.default.node.isRequired,
  sidebar: _propTypes.default.node.isRequired
};
var _default = SettingsLayout;
exports.default = _default;